import * as React from "react";

import "./individual-streets.scss";

import {cs}                     from "@Common/react/chain-services";
import {keyed}                  from "@Common/react/keyed";
import {scc}                    from "@Common/react/state-cascade-change";
import {stateChangeNestedValue} from "@Common/react/state-change-nested-value";
import {UseState}               from "@Common/react/use-state";
import {plural}                 from "@Common/ui-components/language/plural";
import {changeNestedValue}      from "@Common/utils/arr-path";
import {flatten1}               from "@Common/utils/collections";
import {chain}                  from "@Common/utils/fs";

import {SearchInput} from "../../../../../../../../common/design2/search-input/search-input";

import {Table} from "./table/table";

export const IndividualStreets = ({excludedAddressesState, searching, getStreetAddresses, loader}) => cs(
    keyed(JSON.stringify(searching)),
    ["data", ({}, next) => loader.Load({
        feeds: getStreetAddresses(searching),
        next,
    })],
    ({data}) => (
        <div className="individual-streets-2v9">
            <div className="separator"/>

            {cs(
                ["filter", (_, next) => UseState({next})],
                ["match", ({filter}, next) => next(!filter.value? (() => true) : (() => {
                    const lowerCase = filter.value.toLowerCase();
                    return (street) => (
                        street.address .toLowerCase().includes(lowerCase) ||
                        street.zip_code.toLowerCase().startsWith(lowerCase)
                    );
                })())],

                ["records", ({}, next) => next(chain(
                    data.value.map((r) => (
                        r.result.map((addr) => ({
                            ...addr,
                            street: r.feed.address,
                        }))
                    )),
                    flatten1,
                ))],
                ["filteredRecords", ({records, match}, next) => next(chain(
                    records,
                    (_) => !match ? _ : _.filter(match),
                ))],
                ["isExcluded", (_, next) => next((addrRecord) => excludedAddressesState.value?.[addrRecord.street]?.includes(addrRecord.address))],

                ({filter, records, filteredRecords, isExcluded}) => <>
                    <div className="header">
                        <div className="text">
                            <div className="title" xd-qa-type="label" xd-qa-name="Build Radius List Addresses On">
                                Addresses on: {searching.type === "all" ? "All" : searching.address.split("^_^")[0]}
                            </div>
                            <div className="sub-title" xd-qa-type="label" xd-qa-name="Build Radius List Addresses On Description">
                                Uncheck addresses you wish to remove from the list.
                            </div>
                        </div>
                        <div className="controls">
                            {SearchInput({
                                state: filter,
                                placeholder: "Search Address",
                                text: filter.value && <>Found <b>{filteredRecords.length}</b> {plural("address", filteredRecords.length)}</>,
                                xdQaName: "Build Radius List Search Address",
                            })}
                        </div>
                    </div>

                    <div className="box">
                        {/*<pre>{JSON.stringify(excludedAddressesState.value, null, 4)}</pre>*/}
                        {Table({
                            records: filteredRecords,
                            count: {
                                total: records.length,
                                selected: records.filter((addr) => !isExcluded(addr) && addr.display_address !== 0).length,
                            },
                            loading: data.loading,
                            masterCheckbox: (
                                !filteredRecords.find((r) => !isExcluded(r) && !r.do_not_mail) ? {
                                    checked: false,
                                    onClick: () => removeExcludedRecords({records: filteredRecords, state: excludedAddressesState}),
                                } : filteredRecords.find((r) => isExcluded(r)) ? {
                                    checked: "midway",
                                    onClick: () => removeExcludedRecords({records: filteredRecords, state: excludedAddressesState}),
                                } : {
                                    checked: true,
                                    onClick: () => addExcludedRecords   ({records: filteredRecords, state: excludedAddressesState}),
                                }
                            ),
                            getCheckbox: (r) => ({
                                    ...r.display_address == 0 ? {
                                        disabled: r.do_not_mail,
                                        checked: false,
                                    } : (() => {
                                        const checked = !isExcluded(r);
                                        return {
                                            checked,
                                            onClick: () => checked ? (
                                                stateChangeNestedValue(excludedAddressesState, [r.street], (list) => [...list??[], r.address])
                                            ) : (
                                                stateChangeNestedValue(excludedAddressesState, [r.street], (list) => list.filter((a) => a !== r.address))
                                            ),
                                        }
                                    })(),
                                    xdQaName: "Build Radius List "+r.address,
                                }
                            ),
                        })}
                    </div>
                </>
            )}
        </div>
    ),
);


const addExcludedRecords = ({state, records}) => {
    state.change((s) => {
        for (const r of records) {
            s = changeNestedValue(s, [r.street], (list) => {
                if (!list?.includes(r.address) && !r.do_not_mail) {
                    return [...list??[], r.address];
                } else {
                    return list;
                }
            });
        }
        return s;
    });
};

const removeExcludedRecords = ({state, records}) => {
    removeExcludedAddresses({
        state,
        check: ({street, address}) => records.find((r) => r.street === street && r.address === address),
    });
};

const removeExcludedAddresses = ({state, check}) => {
    scc(state, "[*]", (list, {0: street}) => list.filter((address) => !check({street, address})));
};